<template>
  <span @click.stop.prevent class="condition" :class="[{ 'sub-condition': isSubCondition }]">
    <span
      class="d-flex-inline justify-content-between"
      style="cursor: pointer;"
      @click.stop.prevent="handleAction($event, 'conditionEditor', () => { onToggleEditExpression() })"
      :class="[editing && conditionObject.expression != '' ? 'higlight-condition' : '']"
    >
      <condition-preview :expression="conditionObject.expression" style=" border-bottom: 1px solid #fff;" />
      <span class="validation-feedback" :tooltip="$store.state.showTooltips == true ? validationFeedbackMsg : ''">
        <!-- <span :class="[{'valid-result': validCondition}, {'invalid-result': invalidCondition}, {'null-result': nullCondition}]"></span> -->
        <span v-show="validCondition" class="valid-result"><i class="fa-light fa-check-circle"></i></span>
        <span v-show="invalidCondition" class="invalid-result"><i class="fa-light fa-times-circle"></i></span>
        <span v-show="nullCondition" class="null-result"><i class="fa-light fa-exclamation-circle"></i></span>
      </span>
    </span>
    <expression-editor-popover
      v-if="editing"
      :expression="conditionObject.expression"
      :moveLeft="movePanel"
      @expression-updated="onExpressionUpdated"
      @close.once="onToggleEditExpression"
      @click.stop.prevent
      @remove="$emit('remove')"
    />
  </span>
</template>
<script>
import {editorMixin}  from "@/assets/js/editorMixin.js"
import ExpressionEditorPopover from "@/components/ExpressionEditorPopover";
import Condition from "@/components/Condition";
import ConditionPreview from "@/components/ConditionPreview";
import EventBus from "@/assets/js/eventBus.js";

export default {
  name: "condition",
  mixins: [editorMixin],
  data() {
    return {
      editing: false,
      movePanel: false,
      validCondition: false,
      invalidCondition: false,
      nullCondition: false,
      validityCheckError: false
    };
  },
  props: {
    conditionObject: {
      type: Object,
      required: true
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    isSubCondition: {
      type: Boolean
    },
    operator: {
      type: String,
      required: true
    },
    isFirst: {
      type: Boolean
    }
  },
  computed: {
    // a solution to pull out the condition <= and so on.
    validationFeedbackMsg() {
      if (this.validCondition == true) return this.$t("condition-editor.tooltip.valid");
      if (this.invalidCondition == true) return this.$t("condition-editor.tooltip.invalid");
      if (this.nullCondition == true) return this.$t("condition-editor.tooltip.null");
      else return null;
    },
    isDemo() {
      return this.$store.state.editorIsDemoVersion;
    }
  },
  methods: {
    onToggleEditExpression() {
      if (!this.$store.state.showingTemplateBackupInPreview) {
        if (this.conditionObject.expression === "") this.$emit("remove");
        else this.editing = !this.editing;
      }
    },
    onExpressionUpdated(expression) {
      this.conditionObject.expression = expression;
      EventBus.$emit("templateChange");
      this.testExpression();
    },
    enableMoveLeft() {
      this.movePanel = true;
    },
    disableMoveLeft() {
      this.movePanel = false;
    },
    testExpression() {
      this.validityCheckError = false;
      this.validCondition = false;
      this.invalidCondition = false;
      this.nullCondition = false;
      console.log("Expression:", this.conditionObject.expression);
      this.$store.dispatch("testExpression", this.conditionObject.expression).then(
        (result) => {
          if (result.result == "True") {
            this.validCondition = true;
          }
          if (result.result == "False") {
            this.invalidCondition = true;
          }
          if (!this.editing && result.result == null) {
            this.nullCondition = true;
          }
        },
        (error) => {
          console.log(error);
          this.validityCheckError = true;
        }
      );
    }
  },
  components: {
    ExpressionEditorPopover,
    Condition,
    ConditionPreview
  },
  created() {
    if (this.conditionObject.expression === "") this.editing = true;
    this.testExpression();
  },
  updated() {
    // console.count('condition updated')
  },
  mounted() {
    EventBus.$on("move_popover_back", this.disableMoveLeft);
    EventBus.$on("move_popover_left", this.enableMoveLeft);
  },
  destroyed() {
    EventBus.$off("move_popover_back");
    EventBus.$off("move_popover_left");
  }
};
</script>

<style lang="less">
.condition {
  position: relative;

  // &.sub-condition {
  // 	display: inline-block;
  // }
  .variable {
    // text-decoration: underline;
  }

		.expression-editor-popover {	
			width: 300px;
			top: 70px;		
			// left: calc(100% - 388px); 
			left: calc(100% - 388px + 68px); 
			// max-height: calc(90% - 30px);
			max-height: calc(100% - 85px);
			overflow: auto;	

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .expression-editor-wrapper {
    flex: 1 1 auto;
    line-height: 24px;

    p {
      line-height: 24px;
      color: #fff;
    }

    // 	position: fixed;
    // 	z-index: 102;
    // 	left: 0;
    // 	width: 100%;
    // 	padding: 8px;
  }

  .actions {
    display: none;
  }

  &:hover {
    .actions {
      display: inline;

				a {
					&:hover {
						color: #8F979C;
					}
				}
			}
		}
			.validation-feedback{
				position: relative;
				margin-left: 4px;
			}
	}
	.custom-popover.expression-editor-popover.move-left{
		left: calc(100% - 590px);
	}

      a {
        &:hover {
          color: #8f979c;
        }
      }
  .validation-feedback {
    position: relative;
  }
  .invalid-result,
  .valid-result,
  .null-result {
    // position: absolute;
    // top: 0;
    // left: 4px;
    margin-left: 4px;
  }

.custom-popover.expression-editor-popover.move-left {
  left: calc(100% - 590px);
}

//Not ready to highlight yet

// .higlight-condition{
// 	padding: 5px 10px;
// 	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.836);
// 	background-color: #fff;
// 	color: rgb(59, 59, 59);
// 	border-radius: 5px;
// }
</style>
